interface SelectObjectDefault {
  value: string;
  updated_on: string | null;
}

type SelectRawDefault = string | SelectObjectDefault;

/**
 * Extracts a string choice value from the API default_value.
 * API sends status/select defaults as {value: "complete", updated_on: null}
 * or as a plain string. Returns undefined for empty strings.
 * Reused by status field config.
 */
export const normalizeSelectDefaultValue = (value: SelectRawDefault): string | undefined => {
  const raw = typeof value === "object" ? value.value : value;
  return raw === "" ? undefined : raw;
};
